export  default [
    {
        "reviewcode": "S36378E",
        "reviewrname": "SIVA GOVARDHAN REDDY",
        "reviewdate": " 01 Feb, 2022",
        "description": "Hospitality is great.very good and supportive staff .Mr.Guru served us very nice drinks.Food is also very good.overall very nice experience.kids loved all the activities.",
        "ratingnumber": "4"
    },
    {
        "reviewcode": "C23271",
        "reviewrname": "KUSUMA",
        "reviewdate": "31 Jan, 2022",
        "description": "Mist Resort provided me with a once-in-a-lifetime experience. I'm itching to come back. A tranquil campus, beautiful and natural infrastructure, lovely lights at night, and exciting excursions.",
        "ratingnumber": "2"
    },
    {
        "reviewcode": "C23283",
        "reviewrname": "SASWATI",
        "reviewdate": "31 Jan, 2022",
        "description": "It was a very good experience there. we enjoyed a lot. Service and food quality are very good",
        "ratingnumber": "4"
    },
    {
        "reviewcode": "C23281",
        "reviewrname": "THOUSIF",
        "reviewdate": "31 Jan, 2022",
        "description": "Its nice place for day outing with family",
        "ratingnumber": "5"
        
    },
    {
        "reviewcode": "D94289D",
        "reviewrname": "TR NAGARAJA",
        "reviewdate": "30 Jan, 2022",
        "description": "All r good.. Except break fast is worst.... Launch is ok ok.. Not too good it's okb",
        "ratingnumber": "4"
        
    },
    {
        "reviewcode": "C23244",
        "reviewrname": "RAJESH",
        "reviewdate": "30 Jan, 2022",
        "description": "panni purl was very tasty and like it very much.",
        "ratingnumber": "4"
        
    },
    {
        "reviewcode": "C23266",
        "reviewrname": "SHRUTI",
        "reviewdate": "29 Jan, 2022",
        "description": "Beautiful property , great ambience and good food.",
        "ratingnumber": "4"
        
    },
    {
        "reviewcode": "C23244",
        "reviewrname": "RAJESH",
        "reviewdate": "30 Jan, 2022",
        "description": "panni purl was very tasty and like it very much.",
        "ratingnumber": "4"
        
    },
    {
        "reviewcode": "C23266",
        "reviewrname": "SHRUTI",
        "reviewdate": "29 Jan, 2022",
        "description": "Beautiful property , great ambience and good food.",
        "ratingnumber": "4"
        
    }
]